export enum StateNamespace {
  APP = "app",
  AUTH = "auth",
  BREAKS = "breaks",
  CHAT = "chat",
  PLAN = "plan",
  SUBSCRIPTION = "subscription",
  THERAPIST = "therapist",
  USER = "user",
  QUESTIONNAIRE = "questionnaire",
  USER_LEGAL_AGREEMENT = "userLegalAgreement",
  CUSTOMER = "customer",
  PATIENTS_POOL = "patients_pool",
  PROFESSIONAL_VIEW = "professionalView",
  BROWSER_NOTIFICATION = "browser_notification",
  PUSH_NOTIFICATIONS = "push_notifications",
  PAYMENT = "payment",
  HELP = "help",
  REASSIGN = "reassign",
  SESSIONS = "sessions",
  SCHEDULE = "schedule",
  VIDEO_CALL = "videoCall",
  INVOICES = "invoices",
  ACTIVITY_CENTER = "activityCenter",
  ON_BOARDING = "on_boarding",
  PRIVACY = "privacy",
  PAYMENT_RECEIPTS = "payment_receipts",
  BOT = "bot",
  CLINICAL_HISTORY = "clinical_history",
  AGENT = "agent",
}
